import type { ItemSelecionado } from '@/types/servico';

/** Linhas para `ordem_servico_itens`. por_hora nasce a 0 (calculado pelo tempo). */
export function construirItensOS(itens: ItemSelecionado[]) {
  return itens.map((item) => {
    const porHora = item.servico.tipo_preco === 'por_hora';
    return {
      servico_id: item.servico.id,
      servico_nome: item.servico.nome,
      quantidade: porHora ? 0 : item.quantidade,
      valor_unitario: item.servico.valor_base,
      valor_total: porHora ? 0 : item.servico.valor_base * item.quantidade,
    };
  });
}

/** Snapshot legado `os.servicos`. por_hora leva valor 0. */
export function construirServicosLegacy(itens: ItemSelecionado[]) {
  return itens.map((item) => ({
    tipo: item.servico.id,
    descricao: item.servico.nome,
    valor: item.servico.tipo_preco === 'por_hora' ? 0 : item.servico.valor_base * item.quantidade,
  }));
}
